import React, { useState, useEffect } from "react";
import AgendaBookRundownJson from "../components/AgendaBookRundownJson";
import AgendaBookPersonnelJson from "../components/AgendaBookPersonnelJson";
import AgendaBookFinanceJson from "../components/AgendaBookFinanceJson";
import TopNavTabs from "../components/TopNavTabs";
import { isZh } from "../utils/language";


export default function AgendaBookMainPanel({
  selectedAgenda,
  lunarInfo,
  tabs,
  activeTab,
  onTabChange,
  permsReady,
  agendaBook,
  onRundownUpdated,
  onPersonnelUpdated,
  onFinanceUpdated,
  agendaBookReady,
  id,
  history
}) {

/* ================= MAIN PANEL ================= */
  if (!permsReady) {
    return <div className="empty">Memeriksa hak akses…</div>;
  }

  if (!selectedAgenda || !agendaBookReady) {
    return (
      <div style={{
        padding: "2rem",
        textAlign: "center",
        color: "#64748b"
      }}>
        {isZh() ? "載入中..." : "Loading..."}
      </div>
    );
  }

  if (!tabs.length) {
    return <div className="empty">Anda tidak memiliki akses ke Agenda Book.</div>;
  }

  /* ringkasan agenda (mirip DetailAgenda) */
  const src = selectedAgenda?.attributes || selectedAgenda || {};
  const subject = (isZh() ? src.subject_zh : src.subject) || "";
  const agendaDate = src.agendaDate;
  const areaLabel = src?.area?.name || src?.area?.shortname || "";

  return (
    <div>
      {/* ===== HEADER AGENDA ===== */}
      <div className="detail-agenda" style={{ paddingRight: 0 }}>
        <div className="da-toprow">
          <div className="da-dateblock">
            <div className="da-date-main">
              {agendaDate ? new Date(agendaDate).toLocaleDateString("id-ID", { weekday: "long" }) + " " + new Date(agendaDate).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" }) : "—"}
            </div>
            {lunarInfo && (
            <div className="da-date-range" style={{ marginTop: "0.125rem" }}>
                歲次{lunarInfo.lunarGanZhi}  {lunarInfo.leapMonth ? "閏" : ""}{lunarInfo.lunarMonth}月{lunarInfo.lunarDay}日 
            </div>
            )}
          </div>
        </div>

        <div className="da-titlewrap">
          {areaLabel && (
            <div className="area-badge area-cat1">{areaLabel}</div>
          )}
          <div className="da-title">{src.subject_zh}</div>
          <div className="da-subtitle">
            {src.subject} {/*capitalizePinyin(toPinyinSync(subject))*/}
          </div>
        </div>
      </div>

      {/* ===== TABS ===== */}
      <div style={{ margin: "0.75rem 0" }}>
        <TopNavTabs
          items={tabs}
          activeKey={activeTab}
          onTabClick={(k) => {
            onTabChange(k);
            history.replace(`/agendabook/${id}?tab=${k}`);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        />
      </div>

      {/* ===== CONTENT ===== */}
      <div
        style={{
          background: "#fff",
          borderRadius: "0.5rem",
          border: "1px solid #e6eef8",
          padding: "1rem",
        }}
      >
        {/* ===== RUNDOWN TAB ===== */}
        {activeTab === "rundown" && !agendaBookReady && (
          <div style={{ padding: "0.5rem", color: "#64748b" }}>
            Loading agenda book…
          </div>
        )}
        
        {activeTab === "rundown" && agendaBookReady && (
          <AgendaBookRundownJson
            agendaId={src.documentId}
            agendaBookId={agendaBook?.documentId}
            agendaRundowns={agendaBook?.agendaRundowns || []}
            onRundownUpdated={onRundownUpdated} 
          />
        )}
        {activeTab === "personnel" && agendaBookReady && (
          <AgendaBookPersonnelJson
            agendaId={src.documentId}
            agendaBookId={agendaBook?.documentId}
            agendaPersonnels={agendaBook?.agendaPersonnels || []}
            onPersonnelUpdated={onPersonnelUpdated}
          />
        )}
        {activeTab === "finance" && agendaBookReady && (
          <AgendaBookFinanceJson
            agendaId={src.documentId}
            agendaBookId={agendaBook?.documentId}
            agendaFinances={agendaBook?.agendaFinances || []}
            onFinanceUpdated={onFinanceUpdated}
          />
        )}
      </div>
    </div>
  );

}